import {
  CareTypeDto,
  CareTypeLabelVM,
  CareTypePayloadVM,
  CareTypeTranslation,
} from "../types/care-type.definition";
import {
  getAllCareTypes,
  getCareTypeTranslations,
  createCareType,
  updateCareType,
  deleteCareType,
} from "../webclients/care-types.client";

export const careTypesApi = {
  getAll: async (lang = "fr"): Promise<CareTypeDto[]> => {
    const response = await getAllCareTypes(lang);
    return response.data as CareTypeDto[];
  },

  getTranslations: async (id: number): Promise<CareTypeTranslation[]> => {
    const response = await getCareTypeTranslations(id);
    return response.data as CareTypeTranslation[];
  },

  getTranslationsAsLabelVM: async (id: number): Promise<CareTypeLabelVM> => {
    const translations = await careTypesApi.getTranslations(id);
    const byLang = Object.fromEntries(
      translations.map(t => [t.languageCode, t.label])
    );
    return {
      en: byLang["en"] ?? "",
      fr: byLang["fr"] ?? "",
      ar: byLang["ar"] ?? "",
    };
  },

  create: async (data: CareTypePayloadVM): Promise<CareTypeDto> => {
    const response = await createCareType(data);
    return response.data as CareTypeDto;
  },

  update: async (id: number, data: CareTypePayloadVM): Promise<CareTypeDto> => {
    const response = await updateCareType(id, data);
    return response.data as CareTypeDto;
  },

  delete: async (id: number): Promise<void> => {
    await deleteCareType(id);
  },
};
